//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from "vuex";

export default {
  name: "CategoryCollectionsFilter",
  components: {
    CategoryCollectionsFilterFilters: () => import("@/components/common/CategoryCollectionsFilterFilters/index.vue"),
    CategoryCollectionsFilterSearch: () => import("@/components/common/CategoryCollectionsFilterSearch/index.vue"),
    EntityFiltersWrapper: () => import("@/components/common/EntityFiltersWrapper/index.vue"),
    Section: () => import("@/components/common/Section/index.vue"),
  },
  computed: {
    ...mapGetters({
      filtersType: 'pages/category-collections/filtersType',
      entity: 'pages/category-collections/entity'
    })
  },
  methods: {
    changeType(type) {
      if (this.filtersType !== type && type !== 'close' && type === 'search') {
        this.$store.commit('pages/category-collections/clear')
        this.$store.commit('pages/category-collections/createCategoriesCheckBox')
      }
      if (this.filtersType !== 'close' && this.filtersType !== type && type !== 'close' && type === 'filters') {
        this.$store.dispatch('pages/category-collections/submit')
      }
      this.$store.commit('pages/category-collections/setFiltersType', type)
    }
  }
}
